import { render, staticRenderFns } from "./AspDisplaySettingsRegister.vue?vue&type=template&id=2a39b43e&scoped=true"
import script from "./AspDisplaySettingsRegister.vue?vue&type=script&lang=js"
export * from "./AspDisplaySettingsRegister.vue?vue&type=script&lang=js"
import style0 from "./AspDisplaySettingsRegister.vue?vue&type=style&index=0&id=2a39b43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a39b43e",
  null
  
)

export default component.exports